/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type {
  SwitchOrganizationResponse,
  UserOrganizationMembership,
  UserOrganizationMembershipsResponse,
} from '@modules/cloud-api/v1/types'
import { fetchAsJson } from '@modules/query/helpers'
import type { SaasUserDomain } from '@modules/ui-types'
import { switchOrganizationUrl } from '@modules/cloud-api/v1/authentication'
import { getSaasUserMembershipsUrl } from '@modules/cloud-api/v1/saasUsers'

export interface OrganizationOption extends UserOrganizationMembership {
  domain?: SaasUserDomain
}

export const getUserMemberships: ({
  userId,
  includeRoleAssignments,
}: {
  userId: string
  includeRoleAssignments: boolean
}) => Promise<UserOrganizationMembershipsResponse> = ({ userId, includeRoleAssignments }) =>
  fetchAsJson<UserOrganizationMembershipsResponse>(
    getSaasUserMembershipsUrl({ userId, includeRoleAssignments }),
    {
      method: 'get',
    },
  )

export const switchOrganization: ({
  organizationId,
}: {
  organizationId: string
}) => Promise<SwitchOrganizationResponse> = ({ organizationId }) =>
  fetchAsJson<SwitchOrganizationResponse>(switchOrganizationUrl(), {
    method: 'post',
    body: JSON.stringify({ organization_id: organizationId }),
  })
